import { render, staticRenderFns } from "./ColumnShops.vue?vue&type=template&id=6305dd03"
import script from "./ColumnShops.vue?vue&type=script&lang=ts"
export * from "./ColumnShops.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports